import { Link } from "react-router-dom";
type TopImgesPropsType = {
  chatId: number;
  gettagged: any[];
};

const TagList: React.FC<TopImgesPropsType> = ({ chatId, gettagged }) => {
  const tags = (gettagged || [])
    .map((obj: any) => {
      const tagName = obj?.gettagged?.[0]?.tags_name?.trim();
      const tagId = obj?.tags_id ?? obj?.gettagged?.[0]?.id ?? obj?.id;
      return {
        tagId,
        tagName,
      };
    })
    .filter((tag: any) => Boolean(tag?.tagName));

  return (
    <>
      <div className="card-body">
        <div className="t-link text-center">
          <ul className="m-0 p-0 taglist">
            {tags.map((tag: any) => (
              <li key={`${chatId}-${tag.tagId}-${tag.tagName}`}>
                <Link
                  to={`/disneyland/tag/${tag.tagName
                    .replace(/\s+/g, "-")
                    .toLowerCase()}/`}
                >
                  {tag.tagName}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
};

export const TopTags: React.FC<TopImgesPropsType> = ({ chatId, gettagged }) => (
  <TagList chatId={chatId} gettagged={gettagged} />
);

export const TopTagsLounge: React.FC<TopImgesPropsType> = ({
  chatId,
  gettagged,
}) => <TagList chatId={chatId} gettagged={gettagged} />;
